<template>
    <div class="user_orders_Settings">
        <div class="intro">
            <div class="panel-tag">
                {{ __t('pwa.intro') }}
            </div>
        </div>

        <b-tabs pills card vertical class="">
            <b-tab title-link-class="" :key="item.comp"  :active="item.is_active"  v-for="(item,idx) in pwa_res">
                <template slot="title">
                    <div class="fs-lg px-4 text-center ">
                        {{item.name }}
                    </div>
                </template>

                <b-card-text>
                    <component :client_id="user.client_id" v-bind:is="item.comp" ></component>
                </b-card-text>
            </b-tab>
        </b-tabs>

    </div>
</template>

<script>

import pwa_bg from "./images/pwa_bg";
import pwa_logo from "./images/pwa_logo";
import pwa_splash from "./images/pwa_splash";

export default {
    name: "pwa_images",
    props: {
        user: {
            type: Object
        }
    },
    components: {
        pwa_bg,
        pwa_logo,
        pwa_splash,
    },

    data() {
        return {
            is_loaded : false,
            is_load: false,
            my_files : []
        }
    },
    methods: {

    },

    computed : {
        pwa_res () {
            return [
                {
                    'name' : this.__t('pwa_bg'),
                    'comp' : 'pwa_bg',
                    'is_active' : false,
                },
             /*   {
                    'name' : this.__t('pwa_splash'),
                    'comp' : 'pwa_splash',
                    'is_active' : false,
                },*/
                {
                    'name' : this.__t('pwa_logo'),
                    'comp' : 'pwa_logo',
                    'is_active' : false,
                },
               /* {
                    'name' : this.__t('pwa_color'),
                    'comp' : 'pwa_color',
                    'is_active' : false,
                },*/
            ]
        }

    }

}
</script>

<style scoped>

</style>
